import { Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout";
import { LandingPage } from "./pages/LandingPage";
import { ChatPage } from "./pages/ChatPage";
import { ExplorePage } from "./pages/ExplorePage";
import { PermitsPage } from "./pages/PermitsPage";
import { PermitInfoPage } from "./pages/PermitInfoPage";
import { PermitApplicationPage } from "./pages/PermitApplicationPage";
import { PermitDetailsPage } from "./pages/PermitDetailsPage";
import { SDABExpertPage } from "./pages/SDABExpertPage";
import { QuantitySurveyPage } from "./pages/QuantitySurveyPage";
import { FeasibilityStudyPage } from "./pages/FeasibilityStudyPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { TermsOfServicePage } from "./pages/TermsOfServicePage";
import { BlogPage } from "./pages/BlogPage";
import { BlogPostPage } from "./pages/BlogPostPage";
import { CaptchaDemo } from "./pages/CaptchaDemo";
import { AdminLogin, AdminDashboard } from "./pages/admin";

// Admin route name (should match backend config)
const ADMIN_ROUTE = import.meta.env.VITE_ADMIN_ROUTE || "console";

function App() {
  return (
    <Routes>
      {/* Landing page - standalone without Layout */}
      <Route path="/" element={<LandingPage />} />

      {/* Admin routes (outside main layout, before catch-all) */}
      <Route path={ADMIN_ROUTE} element={<AdminLogin />} />
      <Route path={`${ADMIN_ROUTE}/dashboard`} element={<AdminDashboard />} />

      {/* App routes with Layout */}
      <Route element={<Layout />}>
        {/* Main modules */}
        <Route path="chat" element={<ChatPage />} />
        <Route path="explore" element={<ExplorePage />} />

        {/* Permits module */}
        <Route path="permits" element={<PermitsPage />} />
        <Route path="permits/info" element={<PermitInfoPage />} />
        <Route path="permits/new" element={<PermitApplicationPage />} />
        <Route path="permits/:id" element={<PermitDetailsPage />} />
        <Route path="permits/:id/edit" element={<PermitApplicationPage />} />

        {/* Other modules */}
        <Route path="sdab" element={<SDABExpertPage />} />
        <Route path="quantity-survey" element={<QuantitySurveyPage />} />
        <Route path="feasibility" element={<FeasibilityStudyPage />} />

        {/* Demo/Test pages */}
        <Route path="captcha-demo" element={<CaptchaDemo />} />

        {/* Blog */}
        <Route path="blog" element={<BlogPage />} />
        <Route path="blog/:slug" element={<BlogPostPage />} />

        {/* Legal pages */}
        <Route path="privacy" element={<PrivacyPolicyPage />} />
        <Route path="terms" element={<TermsOfServicePage />} />

        {/* Catch all - redirect to chat */}
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
